import { io } from 'socket.io-client';

let socket = null;
let socketToken = null;

/*
|--------------------------------------------------------------------------
| SOCKET URL
|--------------------------------------------------------------------------
*/

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'https://apiworkorder.perumdamtkr.com';

/*
|--------------------------------------------------------------------------
| GET TOKEN
|--------------------------------------------------------------------------
*/

const getCurrentToken = () => {
  /*
   * API React Anda juga menggunakan localStorage token.
   */
  const directToken =
    localStorage.getItem('token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('auth_token') ||
    localStorage.getItem('sanctum_token');

  if (directToken) {
    return directToken;
  }

  /*
   * Fallback jika token tersimpan dalam object user.
   */
  try {
    const rawUser = localStorage.getItem('user');

    if (!rawUser) {
      return null;
    }

    const user = JSON.parse(rawUser);

    return user?.token || user?.access_token || null;
  } catch (error) {
    return null;
  }
};

/*
|--------------------------------------------------------------------------
| DISCONNECT
|--------------------------------------------------------------------------
*/

export const disconnectWorkOrderSocket = () => {
  if (socket) {
    socket.removeAllListeners();

    socket.disconnect();

    socket = null;
  }

  socketToken = null;
};

/*
|--------------------------------------------------------------------------
| GET SOCKET
|--------------------------------------------------------------------------
*/

export const getWorkOrderSocket = () => {
  const token = getCurrentToken();

  if (!token) {
    console.warn('Socket.IO: token tidak ditemukan.');

    return null;
  }

  /*
   * PENTING:
   *
   * Kalau user logout lalu login sebagai user lain,
   * token pasti berubah.
   *
   * Socket lama WAJIB dihancurkan.
   */
  if (socket && socketToken && socketToken !== token) {
    console.log('Socket.IO: token berubah, reconnect dengan user baru.');

    disconnectWorkOrderSocket();
  }

  /*
   * Socket dengan token yang sama masih boleh dipakai.
   */
  if (socket) {
    return socket;
  }

  socketToken = token;

  socket = io(SOCKET_URL, {
    path: '/socket.io',

    transports: ['websocket', 'polling'],

    /*
     * Cara utama.
     */
    auth: {
      token,
    },

    /*
     * Legacy compatibility.
     */
    query: {
      token,
    },

    reconnection: true,

    reconnectionAttempts: Infinity,

    reconnectionDelay: 1000,

    reconnectionDelayMax: 5000,

    timeout: 10000,
  });

  socket.on('connect', () => {
    console.log('Socket connected:', socket.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('Socket disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connect error:', error.message);
  });

  return socket;
};
